import React, { useEffect, useRef, useState } from "react";
import { Button, Card, CardGroup, Col, Container, Ratio, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import Testimonials from "../../../Components/PackagingTestimonials";
import TextTestimonials from "../../../Components/TextTestimonials";
import Contact from "../../../Components/ContactComponent";
import { SimpleResponse } from "../../../Models/ResponseModel";
import pageService from "../../../Services/pageService";
import { PageSummary_SearchRequest } from "../../../Models/Model";
import { ContainerType, PageType } from "../../../Models/Enum";
import FruitCard from "../../../Components/FruitCard";
import Recipe from "./Recipe";
import MasterService from "../../../Services/masterService";
import * as fldExtract from "../../../Helpers/FieldExtractors"
import { FruitCardresponsive, Testimonialsresponsive } from "../../../Helpers/Responsive";
import DetailBannerCarousel from "./DetailBannerCarousel";
import PackagingComponent from "../../../Components/PackagingComponent";
import FarmerTestimonialsComponent from "../../../Components/FarmerTestimonialsComponent";
import PhotoModal from "./PhotoModal";
import { IMAGE_MAIN_ENDPOINT } from "../../../constant";
import PhotoModalIndividual from "./PhotoModalIndividual";
import ContactSignUp from "../../../Components/ContactSignUp";
import ResponsiveGridCarousel from "./abc";
import Gallery from "./abc";
import Sliderfff from "./FruitDetailBanner";
import FruitDetailBanner from "./FruitDetailBanner";




function generateProductBannerElement(item, index, arrProductImages) {
    var data = null;
    var colWidth = 1;
    var colMult = 2;
    var idx = index;
    idx = idx > 2 ? 2 : idx;
    colWidth = idx >= 2 ? 12 : 6 - idx * colMult;
 


    return (
        // <div className={" pe-2 pb-2 col-" + colWidth + (index == 3 ? " pt-3 position-relative" : "")} key={index} >
        //     <div className={"card rounded rounded-5"} style={{ alignItems: 'center', cursor: "pointer", }}  >

        //         <img src={IMAGE_MAIN_ENDPOINT + item.fileName} className={"card-img-top img-fluid rounded rounded-5 "} alt="..." style={{ cursor: "pointer", height: (index > 1 ? "163px" : "350px"), maxHeight: '100%', filter: (index == 3 && arrProductImages.length > 4 ? 'contrast(70%)' : 'none') }} />
        //         {/* {arrProductImages.length > 0 ? <div className="fruitImagesText"><PhotoModal data={arrProductImages} index={index}/></div> : ""} */}
        //         {arrProductImages.length > 0 && index < 3 ? <div className="fruitImagesIndexText"><PhotoModal data={arrProductImages} index={index} /></div> : ""}

        //     </div>
        //     {arrProductImages.length > 4 && index == 3 ? <div className="fruitImagesLast"><PhotoModal data={arrProductImages} index={index} /></div> : ""}
        //     {index == 0 ? <div className="GITags" ><img src="/server-build/Images/GITaggedLabel1.png" /> <img src="/server-build/Images/GITaggedLabel2.png" /></div> : ""}
        // </div>

        <div className={" pe-2 pb-2 col-" + colWidth + (index == 3 ? " pt-3 position-relative" : "")} key={index} >
            <div className={"card rounded rounded-5"} style={{ alignItems: 'center', cursor: "pointer", }}  >

                <img src={IMAGE_MAIN_ENDPOINT + item.fileName} className={"card-img-top img-fluid rounded rounded-5 "} alt="..." style={{ cursor: "pointer", height: (index > 1 ? "163px" : "350px"), maxHeight: '100%', filter: (index == 3 && arrProductImages.length > 4 ? 'contrast(70%)' : 'none') }} />

                {arrProductImages.length > 0 && index < 3 ? <div className="fruitImagesIndexText"><PhotoModal data={arrProductImages} index={index} /></div> : ""}

            </div>
            {arrProductImages.length > 4 && index == 3 ? <div className="fruitImagesLast"><PhotoModal data={arrProductImages} index={index} /></div> : ""}
            {index == 0 ? <div className="GITags" ><img src="/server-build/Images/GITaggedLabel1.png" /> <img src="/server-build/Images/GITaggedLabel2.png" /></div> : ""}
        </div>
    )
}


function FruitDetail(props) {
  

    const x = props.data.URL;
    let titleName = x.substring(10, 15);
    let titleNameLower = titleName.toLowerCase();

    const masterService = MasterService.getInstance();

    if (props != undefined && props != null) {
        var parsedDATA = props.data.ContentJson;
    }


    var DetailTestimonialsSubheading = "What our farmers think about Superplum’s support in transforming their farming journey."
    var DetailTestimonialsHeading = "Farmers Speak"
    var PackagingCard = "Packaging  Variations"


    var arrProductImages = fldExtract.getArraySorted_ZOrder(parsedDATA, 'FLD_1_4_5_5')
    var sortedPackaging = fldExtract.getArraySorted_ZOrder(parsedDATA, 'FLD_0_4_21_21')
    var Months = fldExtract.getFieldValue(parsedDATA, 'FLD_1_7_3_3')
    var dateText = Months.map(({ Start, End }) => ` ${masterService.Months["Month" + Start]} - ${masterService.Months["Month" + End]}`).join(' | ');

    const [pageData, setPageData] = useState();
    const [userData, setUserData] = useState([]);
    const [Url, setUrl] = useState(null);


    useEffect(() => {
        getCardData();

    }, []);

    const getCardData = async () => {

        let req = new PageSummary_SearchRequest();
        req.PageTypeID = PageType.FruitDetail;
        req.ParentPageID = props.data.ParentPageID;

        try {
            let resp: SimpleResponse = await pageService.getInstance().PageSummary_Search(req);
            if (resp.HasError) {
                return;
            }
            setUserData(resp.Result);
        } catch (e) {

        }
    }

    const carouselRef: any = useRef(null);

    const handleNextCard = () => {
        carouselRef.current.state.currentSlide = carouselRef.current.state.currentSlide + 1;

        if (((carouselRef.current.state.currentSlide) + (carouselRef.current.state.slidesToShow)) > carouselRef.current.state.totalItems) {
            carouselRef.current.state.currentSlide = carouselRef.current.state.currentSlide - 1;
            return;
        }

        const nextSlide = carouselRef.current.state.currentSlide;
        carouselRef.current.goToSlide(nextSlide)


    };

    const handlePrevCard = () => {
        if ((carouselRef.current.state.currentSlide) < 1) {
            return;
        }

        const prevSlide = carouselRef.current.state.currentSlide - 1;
        carouselRef.current.goToSlide(prevSlide);
    }



    function createMarkup(html) {
        return { __html: html };
    }


    return (
        <div className="container-fluid">

            <div className="row mb-5 pb-0 pb-lg-5">
                <div className="col">
                    <div className="container">
                        {/* <div className="row mb-5 " style={{columnGap: '20px'}}>
                            <div className="col abc1 ">
                                <img className="img-fluid w-100"  src="/server-build/Images/resize-1736752773575034845Banner61.png" />
                            </div>
                            
                            <div className="col ">
                                <div className="row " style={{paddingBottom:'10px' , columnGap:'18px'}}>
                                    <div className="col  abc2 " >
                                        <img className="img-fluid w-100"  src="/server-build/Images/resize-17367549701217847936Banner61.png" />
                                    </div>
                                    <div className="col abc2" >
                                        <img  className="img-fluid w-100"  src="/server-build/Images/resize-17367549701217847936Banner61.png" />
                                    </div>
                                </div>

                                <div className="row " style={{columnGap: '18px'}}>
                                    <div className="col abc2 " >
                                        <img className="img-fluid w-100"  src="/server-build/Images/resize-17367549701217847936Banner61.png" />
                                    </div>
                                    <div className="col abc2" >
                                        <img className="img-fluid w-100"  src="/server-build/Images/resize-17367549701217847936Banner61.png" />
                                    </div>
                                </div>
                            </div>

                        </div> */}

                   
                        <FruitDetailBanner/>

                    {/* <Gallery/> */}


                        {/* <div className="row mb-5 d-none d-lg-flex">
                            {
                                (arrProductImages != null && arrProductImages.slice(0, 2).map((item, index) => {
                                    return generateProductBannerElement(item, index, arrProductImages);
                                }))
                            }

                            {
                                (arrProductImages != null && arrProductImages.length > 2
                                    &&
                                    <div className="col-2">
                                        <div className="row flex-column">
                                            {
                                                (arrProductImages.slice(2, 4).map((item, index) => {
                                                    return generateProductBannerElement(item, index + 2, arrProductImages);
                                                }))
                                            }
                                        </div>
                                    </div>
                                )
                            }

                        </div> */}

                        <div className="row d-lg-none">
                            <div className="col">
                                <Container className="p-0 position-relative">
                                    <DetailBannerCarousel data={props} />
                                </Container>
                            </div>
                        </div>




                        <div className="row ">
                            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                                <div className="row">
                                    <div className="col">
                                        <h2>{props.data.Name != undefined && props.data.Name != null && props.data.Name}</h2>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-lg-inline-block  w-auto mb-2 mb-md-3 mb-lg-0 ">
                                            <div className="badge customAvailable rounded-pill text-black px-3 py-2 d-lg-inline-block d-md-inline w-auto me-0 me-lg-3">
                                                Grown in: {parsedDATA.FLD_0_1_16_16 != undefined && parsedDATA.FLD_0_1_16_16 != null && parsedDATA.FLD_0_1_16_16}
                                            </div>
                                        </div>
                                        <div className="d-lg-inline-block w-auto">
                                            <div className="badge customFruits rounded-pill text-black d-lg-inline-block d-md-inline px-3 py-2 ">
                                                Available in: {dateText != undefined && dateText != null && dateText}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="mt-4">{parsedDATA.FLD_0_2_1_1 != undefined && parsedDATA.FLD_0_2_1_1 != null && parsedDATA.FLD_0_2_1_1}</div>


                                    </div>
                                </div>
                            </div>

                            <div className=" col-12 col-lg-6">
                                <div className='row justify-content-center align-items-top d-none d-lg-flex'>
                                    <div className=' col-6 col-lg mb-5 mb-lg-0' >
                                        <img className='mb-2 img-fluid' src="../../server-build/Images/GICertifiedSafe.png" alt="zero carbides" />
                                        <p className="fw-semibold">Zero<br className="d-none d-xl-block" /> carbides</p>
                                    </div>
                                    <div className='col-6 col-lg mb-5 mb-lg-0 '>
                                        <img className='mb-2 img-fluid' src="../../server-build/Images/GICertifiedSafe.png" alt="safe" />
                                        <p className="fw-semibold"> Certified safe  <br className="d-none d-xl-block" /> from Pesticides</p>
                                    </div>
                                    <div className='col-6 col-lg '>
                                        <img className='mb-2 img-fluid' src="../../server-build/Images/GI TaggedLabelIcon.png" alt="Traceable" />
                                        <p className="fw-semibold">Traceable to<br className="d-none d-xl-block" />the farms</p>
                                    </div>
                                    <div className='col-6 col-lg  '>
                                        <img className='mb-2 img-fluid' src="../../server-build/Images/GI TaggedLabelIcon2.png" alt="test " />
                                        <p className="fw-semibold">Vire quality & <br className="d-none d-xl-block" /> test reports</p>
                                    </div>

                                </div>

                                <div className='row justify-content-center align-items-center d-lg-none mb-4'>
                                    <div className="col">
                                        <div className="container">
                                            <div className="row mb-4 mb-lg-5">
                                                <div className=' col text-center ' >
                                                    <img className='mb-3 img-fluid' src="../../server-build/Images/GI TaggedLabelIcon3.png" alt="zero carbides" />
                                                    <p className="fw-semibold">Free of
                                                        <br /> Carbides</p>
                                                </div>
                                                <div className='col   text-center'>
                                                    <img className='mb-3 img-fluid' src="../../server-build/Images/GICertifiedSafe.png" alt="safe" />
                                                    <p className="fw-semibold"> Pesticide
                                                        <br /> Tested</p>
                                                </div>
                                            </div>

                                            <div className="row ">
                                                <div className='col text-center '>
                                                    <img className='mb-3 img-fluid' src="../../server-build/Images/GI TaggedLabelIcon.png" alt="Traceable" />
                                                    <p className="fw-semibold">Traceable to<br />the farms</p>
                                                </div>
                                                <div className='col text-center '>
                                                    <img className='mb-3 img-fluid' src="../../server-build/Images/GI TaggedLabelIcon2.png" alt="test " />
                                                    <p className="fw-semibold">Washed &
                                                        <br /> Cleaned</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <p className="fw-bold">Shop at:</p>
                                        <div className="row ">
                                            <div className="col-auto mb-2 ps-0 ">
                                                <a href="https://www.amazon.in/stores/page/4D65A250-EEC0-4A71-A57B-CD87903FA9E7?ingress=3" target='_blank'><img src="../../server-build/Images/Amazon.png" /></a>
                                            </div>
                                            <div className="col-auto mb-2 ps-0 ">
                                                <a href="https://shop.superplum.com/collections/frontpage" target='_blank'> <img src="../../server-build/Images/BuyDirect.png" className="img-fluid" alt="direct buy" /></a>
                                            </div>
                                            {/* <div className="col-auto mb-2 ps-0  ">
                                            <a href="https://www.zeptonow.com/search?query=superplum" target='_blank'> <img src="../../server-build/Images/Zepto.png" className="img-fluid" alt="zepto" /></a>
                                            </div> */}
                                            <div className="col-auto mb-2 ps-0">
                                                <a href="https://shop.superplum.com/collections/frontpage" target='_blank'> <img src="../../server-build/Images/Instamart.png" className="img-fluid" alt="instamart" /></a>
                                            </div>
                                            <div className="col-auto mb-2 ps-0">
                                                <a href="https://shop.superplum.com/collections/frontpage" target='_blank'> <img src="../../server-build/Images/LocalStores.png" className="img-fluid" alt="local stores" /></a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row  pb-0 pb-lg-5 mb-5 ">
                <div className="col">
                    <div className="row " style={{ backgroundColor: '#f4f4f4' }}>
                        <div className="col">
                            <div className="container">
                                <div className="row pt-4 pt-lg-5 pb-lg-5 pt-0 pb-0 ">
                                    <div className="col-12 col-lg-6 col-xl-5 mb-4 mb-lg-0 pt-3 pt-lg-0  ps-lg-2 pe-lg-2">
                                        <h2>{parsedDATA.FLD_0_1_17_17 != undefined && parsedDATA.FLD_0_1_17_17 != null && parsedDATA.FLD_0_1_17_17}</h2>
                                        <p style={{ fontWeight: 500 }}>{parsedDATA.FLD_0_1_18_18 != undefined && parsedDATA.FLD_0_1_18_18 != null && parsedDATA.FLD_0_1_18_18}</p>
                                        <p className="mb-4 d-none d-lg-flex" style={{ whiteSpace: "pre-line" }}>{parsedDATA.FLD_0_2_19_19 != undefined && parsedDATA.FLD_0_2_19_19 != null && parsedDATA.FLD_0_2_19_19} </p>
                                        <p className="mb-4 d-lg-none" >{parsedDATA.FLD_0_2_19_19 != undefined && parsedDATA.FLD_0_2_19_19 != null && parsedDATA.FLD_0_2_19_19} </p>

                                        <Button href="https://shop.superplum.com/collections/frontpage" target='_blank' className="blackButton rounded-pill mb-3 mb-lg-0 " >Know More</Button>
                                    </div>
                                    <div className="col-xl-1 d-none d-xl-flex"></div>


                                    <div className="col-12  col-lg-6 col-xl-6 ps-0 pe-0 ps-lg-auto d-none d-lg-block">
                                        {/* <img className="img-fluid" src="../../server-build/Images/GITaggedLabel.png" style={{ float: 'right' }} /> */}
                                        <img className="img-fluid " alt="know more" style={{ float: 'right', borderRadius: '20px' }} src={IMAGE_MAIN_ENDPOINT + (parsedDATA.FLD_0_3_34_34 != undefined && parsedDATA.FLD_0_3_34_34 != null && parsedDATA.FLD_0_3_34_34)} />



                                    </div>
                                </div>
                            </div>
                            <div className="row d-lg-none justify-content-center">
                                <div className="col-auto p-0">
                                    <img className="img-fluid " src="../../server-build/Images/GITaggedLabel.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {props != undefined && props != null && props.data.ContentJson != undefined && <div className='row ps-0 ps-lg-2 mb-5 pb-0 pb-lg-5 position-relative packagingCategory' >
                <div className='col'>
                    <PackagingComponent data={props.data.ContentJson.FLD_0_4_21_21} Heading={PackagingCard} />
                </div>
            </div>}


            <div className="row mb-5  journeyBg justify-content-center align-items-center " style={{ backgroundImage: "url(" + IMAGE_MAIN_ENDPOINT + (parsedDATA.FLD_0_3_22_22) }}>
                <div className="col">
                    <Container >
                        <div className="row justify-content-center align-items-center">
                            <div className="col text-center">
                                <h2 className="text-white lh-base mb-5 "> Our {titleNameLower}’s journey <br /> of freshness</h2>

                                <img className="img-fluid w-100 mb-5" src={IMAGE_MAIN_ENDPOINT + (parsedDATA.FLD_0_3_35_35 != undefined && parsedDATA.FLD_0_3_35_35 != null && parsedDATA.FLD_0_3_35_35)} />
                                <Button className="whiteButton rounded rounded-5 fw-bold" href={parsedDATA.FLD_0_1_23_23} target='_blank'>View Video</Button>


                            </div>
                        </div>
                    </Container>

                </div>
            </div>



            <div className="row mb-3 mb-lg-5 pt-0 pt-lg-5">
                <div className="col">
                    <img className="img-fluid w-100" src={IMAGE_MAIN_ENDPOINT + (parsedDATA.FLD_0_3_24_24 != undefined && parsedDATA.FLD_0_3_24_24 != null && parsedDATA.FLD_0_3_24_24)} />
                </div>
            </div>

            <div className="row align-items-center justify-content-center mb-5 pb-0 pb-lg-5">
                <div className="col-auto p-0">
                    <h2 className="text-center mb-2 mb-lg-4">Where Flavour takes root</h2>
                    <img className="img-fluid mb-0 mb-lg-4" src={IMAGE_MAIN_ENDPOINT + (parsedDATA.FLD_0_3_25_25 != undefined && parsedDATA.FLD_0_3_25_25 != null && parsedDATA.FLD_0_3_25_25)} />
                    <div className="text-center">
                        <span className="d-none d-lg-inline-block fw-bold">Learn more about farm area: </span> &nbsp; &nbsp;
                        <div className="d-lg-none  mb-3 fw-bold">Learn more about farm area: </div>
                        <Button href="https://shop.superplum.com/collections/frontpage" target='_blank' className="blackButton rounded-pill me-2 ">{parsedDATA.FLD_0_1_16_16 != undefined && parsedDATA.FLD_0_1_16_16 != null && parsedDATA.FLD_0_1_16_16}</Button>
                        {/*<Button href="https://shop.superplum.com/collections/frontpage" target='_blank' className="blackButton rounded-pill fw-bold">Karnatka</Button> */}
                    </div>
                </div>
            </div>


            <div className="row DetailFarmerBackground pt-3 pb-3 align-items-center justify-content-center mb-5 position-relative d-none d-lg-flex">
                <div className="col">
                    <Container>
                        <div className="row position-absolute" style={{ top: '41px' }}>
                            <div className="col-3  text-white">
                                <h1 className="pt-lg-0 pt-xl-5 mb-3">Meet your <br />{titleNameLower} Farmers</h1>

                                <p > When you trace your favourite {titleNameLower} back<br className="d-xl-flex d-none" />
                                    to the farm, you can also see the farmer<br className="d-xl-flex d-none" />
                                    who grew and harvested the fruit.</p>
                            </div>
                            <div className="col-3 mb-3 mb-lg-0 pt-5">
                                <img src="../../server-build/Images/FarmerFriendlyPractices3.png" className="DetailFarmer img-fluid" />
                                <div className="DetailFarmerBar text-center text-white pt-2 pb-2" >Farmer Name, State <br /> GPS Details</div>
                            </div>
                            <div className="col-3 mb-3 mb-lg-0 pb-5">
                                <div className="DetailFarmerBar text-center text-white pt-2 pb-2 ">Farmer Name, State <br /> GPS Details</div>
                                <img src="../../server-build/Images/FarmerFriendlyPractices3.png" className="DetailFarmerBottom img-fluid" />

                            </div>
                            <div className="col-3 mb-3 mb-lg-0 pt-5">
                                <img src="../../server-build/Images/FarmerFriendlyPractices3.png" className="DetailFarmer img-fluid" />
                                <div className="DetailFarmerBar text-center text-white pt-2 pb-2" >Farmer Name, State <br /> GPS Details</div>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>

            <div className="row d-lg-none DetailFarmerMobile  pt-5 pb-5 mb-5" style={{ backgroundColor: '#3a785d' }}>
                <div className="col">
                    <div className="row ps-2 pe-4 ">
                        <div className="col text-white">

                            <h2 className="mb-3">Meet your mango farmers</h2>
                            <p>When you trace your favourite mango back
                                to the farm, you can also see the farmer who
                                grew and harvested the fruit.</p>

                            <div className=" mt-5">
                                <FontAwesomeIcon icon={faArrowLeftLong} className='pe-3 fa-2xl' style={{ cursor: ' pointer' }} onClick={handlePrevCard} /> &nbsp;
                                <FontAwesomeIcon icon={faArrowRightLong} className=' fa-2xl' style={{ cursor: 'pointer' }} onClick={handleNextCard} />
                            </div>
                        </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col ps-3 pe-2">
                            <Carousel responsive={Testimonialsresponsive} ref={carouselRef} arrows={false} ssr className="mb-3 mb-lg-0"  >
                                <div className="pt-5  me-3">
                                    <img src="../../server-build/Images/FarmerFriendlyPractices3.png" className=" img-fluid" />
                                    <div className="DetailFarmerBar text-center text-white pt-2 pb-2" >Farmer Name, State <br /> GPS Details</div>
                                </div>
                                <div className="me-3 mt-5">
                                    <div className="DetailFarmerBar text-center text-white pt-2 pb-2 ">Farmer Name, State <br /> GPS Details</div>
                                    <img src="../../server-build/Images/FarmerFriendlyPractices3.png" className=" img-fluid" />

                                </div>
                                <div className="me-3 pt-5 ">
                                    <img src="../../server-build/Images/FarmerFriendlyPractices3.png" className=" img-fluid" />
                                    <div className="DetailFarmerBar text-center text-white pt-2 pb-2" >Farmer Name, State <br /> GPS Details</div>
                                </div>

                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>


            {/* <div className='row mb-5 pb-0 pb-lg-5 pt-0 pt-lg-5 position-relative farmerCardDetail'>
                <div className='col'>
                    <Container>
                        <div className='row position-absolute w-100'>
                            <div className='col-xl-2 col-lg-4 detailTestimonialCard'>
                                <h2 className='fw-bold mb-3 mb-lg-4'> Lorem ipsu
                                    testimonials</h2>
                                <p className='fw-bold mb-3 mb-lg-5'>
                                    Lorem ipsum dolor sit amet,
                                    consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua.
                                </p>
                                <div className='d-none d-lg-flex justify-content-evenly '>
                                    <FontAwesomeIcon icon={faArrowLeft} className='fa-xl' />
                                    <FontAwesomeIcon icon={faArrowRight} className='fa-xl' />
                                </div>
                                <div className='d-lg-none '>
                                    <FontAwesomeIcon icon={faArrowLeft} className='fa-xl pe-5' />
                                    <FontAwesomeIcon icon={faArrowRight} className='fa-xl' />
                                </div>
                            </div>
                            <div className='col-xl-10 col-lg-8 p-0 mb-3 mb-lg-0' >
                                <Carousel responsive={Testimonialsresponsive} ssr  >
                                    {parsedDATA.FLD_0_9_27_27 != undefined && parsedDATA.FLD_0_9_27_27.length > 0 && parsedDATA.FLD_0_9_27_27.map((item, index) => (
                                        <div key={index} className='ps-2 pe-2'>
                                            <TextTestimonials item={item} />

                                        </div>
                                    ))}

                                </Carousel>
                            </div> */}

            {/* <div className='col-12'>
                                <div className='d-lg-none justify-content-evenly'>
                                    <FontAwesomeIcon icon={faArrowLeft} className='fa-xl' />&nbsp; &nbsp;
                                    <FontAwesomeIcon icon={faArrowRight} className='fa-xl' />
                                </div>
                            </div> */}
            {/* </div>
                    </Container>
                </div>
            </div> */}


            {props != undefined && props != null && props.data.ContentJson != undefined && <div className='row mb-5 ps-0 pb-0 pb-lg-5 pt-0 pt-lg-5 position-relative farmerCardDetail' >
                <div className='col'>
                    <FarmerTestimonialsComponent data={props.data.ContentJson.FLD_0_9_27_27} Heading={DetailTestimonialsHeading} SubHeading={DetailTestimonialsSubheading} />
                </div>
            </div>}


            <div className="row mb-5 pb-0 pb-lg-5 ">
                <div className="col">
                    <Container>


                        <div className="row justify-content-center mb-4 mt-0 mt-lg-3">
                            <div className="col-auto text-center">
                                <h2>Discover Other {titleName} Varieties</h2>
                            </div>
                        </div>

                        {/* <div className="row mb-4">
                            <div className="col ps-2">
                                <Carousel responsive={FruitCardresponsive} ssr className="mb-4"  >
                                    {userData != undefined && userData.length > 0 && userData.map((item, index) => (
                                        <div key={index} className='ps-2 pe-2'>
                                            <FruitCard key={index} item={item} />

                                        </div>
                                    ))}
                                </Carousel>
                            </div>
                        </div> */}

                        <div className="row CardCarousel mb-4">
                            <div className="col">
                                <Carousel responsive={FruitCardresponsive} ssr swipeable={true} draggable={true} >
                                    {userData != undefined && userData.length > 0 && userData.map((item, index) => (
                                        <div key={index} className='ps-2 pe-2  ' >
                                            <FruitCard item={item} />
                                        </div>
                                    ))}
                                </Carousel>
                            </div>
                        </div>


                        <div className="row justify-content-center ">
                            <div className="col-auto text-center">
                                <Button href="/Products" target='_blank' className="blackButton rounded-pill me-0 me-lg-3 d-block d-lg-inline-block  mb-2 mb-lg-0 fw-bold">View all fruits</Button>
                                <Button href="/Products/Mango" target='_blank' className="whiteButton rounded-pill d-block d-lg-inline-block fw-bold">View all mangoes</Button>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>





            <div className="row mb-5 pb-0 pb-lg-5">
                <div className="col">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-12 col-lg text-center">
                                {/* <img src="../../server-build/Images/GITaggedLabelmango.png" className="img-fluid" alt="how to store" /> */}
                                <img className="img-fluid mb-0 mb-lg-4" alt="how to store" src={IMAGE_MAIN_ENDPOINT + (parsedDATA.FLD_0_3_28_28 != undefined && parsedDATA.FLD_0_3_28_28 != null && parsedDATA.FLD_0_3_28_28)} />
                            </div>
                            <div className="col-12 col-lg">
                                <h4 className="mb-4 fw-bold">How to Store</h4>
                                {/* <ul>
                                        <li>{parsedDATA.FLD_0_29}</li>
                                    </ul> */}
                                <ul dangerouslySetInnerHTML={{ __html: parsedDATA.FLD_0_2_29_29 }} style={{ whiteSpace: "pre-line" }} />


                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-5 pb-0 pb-lg-5">
                <div className="col">
                    <Container>
                        <div className="row">
                            <div className="col">
                                <h2>Nutrition Information</h2>
                                <p className="mb-4"><span className="border-bottom border-success border-2 pb-2">Serving Size:</span> {parsedDATA.FLD_0_1_55_55}</p>

                                <div dangerouslySetInnerHTML={{ __html: parsedDATA.FLD_0_2_56_56 }} ></div>
                                {/* <div className="row">
                                    <div className="col">
                                        <div className="row fw-bold border-bottom pt-3 pb-3 text-secondary">
                                            <div className="col">NUTRIENT</div>
                                            <div className="col">VALUE</div>
                                            <div className="col">% DAILY VALUE</div>
                                        </div>
                                        <div className="row border-bottom pt-3 pb-3">
                                            <div className="col">Fat</div>
                                            <div className="col">1.1g</div>
                                            <div className="col">10%</div>
                                        </div>
                                        <div className="row border-bottom pt-3 pb-3">
                                            <div className="col">Fibre</div>
                                            <div className="col">1.1g</div>
                                            <div className="col">10%</div>
                                        </div>
                                        <div className="row border-bottom pt-3 pb-3">
                                            <div className="col">Vitamin C</div>
                                            <div className="col">1.1g</div>
                                            <div className="col">10%</div>
                                        </div>
                                        <div className="row border-bottom pt-3 pb-3">
                                            <div className="col">Sugars</div>
                                            <div className="col">1.1g</div>
                                            <div className="col">10%</div>
                                        </div>
                                        <div className="row border-bottom pt-3 pb-3">
                                            <div className="col">Vitamin D</div>
                                            <div className="col">1.1g</div>
                                            <div className="col">10%</div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </Container>

                </div>
            </div>

            {/* <div className="row mb-5 pb-0 pb-lg-5">
                <div className="col">
                    <Recipe data={parsedDATA} />
                </div>
            </div> */}



            <div className="row mb-5 pb-0 pb-lg-5">
                <div className="col">

                    <ContactSignUp />
                </div>
            </div>



        </div>
    )
}

export default FruitDetail